export default defineNuxtPlugin((nuxtApp) => {
  useHead({
    script: [
      {
        src: 'https://www.googletagmanager.com/gtag/js?id=G-H0CEKP9VW1',
        async: true
      },
      {
        children: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-H0CEKP9VW1', { page_path: window.location.pathname });
        `,
        type: 'text/javascript'
      } as any
    ]
  })

  nuxtApp.hook('page:finish', (context) => {
    if (typeof window !== 'undefined' && (window as any).gtag) {
      ;(window as any).gtag('config', 'G-H0CEKP9VW1', {
        page_path: window.location.pathname
      })
    }
  })
})